export default __webpack_public_path__ + "static/media/tituloES.a93c2826.png";